import { dateIsAfter, dateIsBefore, addDays } from 'lib/dateUtils'

const ALL_FLEXIBLE_CANCELLATION_POLICIES = [
  'partner-policy-prior-to-check-in-twenty-one-days',
  'flexible-cancellation-forty-five-days',
]

export const isConnectionCancellationPolicy = (cancellationPolicy: App.OrderCancellationPolicyTypes): cancellationPolicy is App.OrderConnectionCancellationPolicy => ('policyCode' in cancellationPolicy)

export const isCancellationPolicy = (cancellationPolicy: App.OrderCancellationPolicyTypes): cancellationPolicy is App.OrderCancellationPolicy => ('type' in cancellationPolicy)

export const creditsOnlyCancellationPolicy = (cancellationPolicy: App.OrderCancellationPolicyTypes) => {
  return cancellationPolicy && isCancellationPolicy(cancellationPolicy) &&
    cancellationPolicy.type === 'credit-only-prior-to-check-in-fourteen-days'
}

export const isFlexibleCancellationPolicy = (
  cancellationPolicy: App.OrderCancellationPolicyTypes,
) => {
  return cancellationPolicy && isCancellationPolicy(cancellationPolicy) &&
    ALL_FLEXIBLE_CANCELLATION_POLICIES.includes(cancellationPolicy.type)
}

export const isWithinSevenDays = (purchaseDate, checkIn, now) => {
  return dateIsAfter(addDays(new Date(purchaseDate), 7), new Date(now)) && dateIsBefore(addDays(new Date(now), 14), new Date(checkIn))
}

export const getFlexibleCancellationDays = (cancellationPolicy: App.OrderCancellationPolicy) => {
  if (cancellationPolicy.type === 'flexible-cancellation-forty-five-days') {
    return 45
  }

  return 21
}
